import _ from 'lodash';
export function withCache(func){
    var cache={}
    return async function(arr,...args){
        var pool={}
        arr=_.uniq(arr).filter(it=>it)
        arr=arr.filter(i=>{
            if(cache[i]!==undefined){
                pool[i]=cache[i]
                return false
            }
            return true
        })
        if(!arr.length)return pool
        var res=await func(arr,...args)
        pool={...pool,...res}
        cache={...cache,...res}
        return pool
    }
}